import React from 'react';
import './Loading.css';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  text?: string;
}

/**
 * Loading Spinner Component
 * Uses Radix Colors pink accent
 */
export const Loading: React.FC<LoadingProps> = ({ 
  size = 'md', 
  fullScreen = false,
  text 
}) => {
  const sizeClass = `loading-spinner-${size}`;
  
  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        <div className={`loading-spinner ${sizeClass}`}>
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
          <div className="loading-spinner-ring"></div>
        </div>
        {text && <p className="loading-text">{text}</p>}
      </div>
    );
  }
  
  return (
    <div className="loading-container">
      <div className={`loading-spinner ${sizeClass}`}>
        <div className="loading-spinner-ring"></div>
        <div className="loading-spinner-ring"></div>
        <div className="loading-spinner-ring"></div>
      </div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

/**
 * Skeleton Component for loading states
 * Shows animated placeholder
 */
interface SkeletonProps {
  width?: string;
  height?: string;
  className?: string;
  count?: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ 
  width = '100%', 
  height = '1rem',
  className = '',
  count = 1
}) => {
  const skeletons = Array.from({ length: count }, (_, i) => (
    <div 
      key={i}
      className={`skeleton ${className}`}
      style={{ width, height }}
    />
  ));
  
  return <>{skeletons}</>;
};

/**
 * Card Skeleton - for loading cards
 */
export const CardSkeleton: React.FC = () => {
  return (
    <div className="premium-card skeleton-card">
      <Skeleton width="60px" height="60px" className="mb-4" />
      <Skeleton width="80%" height="1.5rem" className="mb-2" />
      <Skeleton width="100%" height="1rem" className="mb-2" />
      <Skeleton width="90%" height="1rem" className="mb-4" />
      <Skeleton width="120px" height="2.5rem" />
    </div>
  );
};

export default Loading;

